<template>
  <div>

    <div class="row justify-content-end">
      <a class="btn btn-primary next-step" @click="nextUnit()" :class="units.length - 1 == showIndex ? 'disabled' : ''"
         v-if="units.length > 1">
        <span class="small">{{ __('lang.kwl.edit_next_unit') }}</span>
        <svg class="icon icon-xs pl-1 m-0">
          <use xlink:href="/assets/img/icon-sprite.svg#global.next" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
        </svg>
      </a>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="accordion" id="accordionUnitsDevices">
          <div class="row mb-2 align-items-center" v-for="(unit, index) in units" v-if="unit.rooms.length > 0">
            <div class="col-auto pr-0">
              <button class="btn btn-block d-flex align-items-center text-left no-gutters collapsed"
                      :class="checkMoisureProtection(unit) ? '' : 'disabled'" data-toggle="collapse"
                      v-b-toggle="'unit_' + index">
                                <span class="col-auto pr-3">
                                    <svg class="icon m-0">
                                        <use xlink:href="/assets/img/icon-sprite.svg#global.collapse"
                                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                    </svg>
                                </span>
                <span class="col-auto">{{ unit.getSpecification(__) }}</span>
              </button>
            </div>
            <span class="col-auto pl-0" v-if="!unit.checkSpace()">
                            <a role="button" tabindex="0"
                               v-b-popover.hover.right="__('lang.kwl.room_overview.space_info')">
                                <svg class="icon m-0 mb-1 text-primary">
                                    <use xlink:href="/assets/img/icon-sprite.svg#global.warning"
                                         xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                </svg>
                            </a>
                        </span>
            <!--                         <span class="col-auto pl-0" v-if="true == false">
                <a role="button" v-b-popover.hover.right="__('lang.kwl.device_selection.rooms_not_valid')" tabindex="0">
                    <svg class="icon m-0 mb-1 text-primary">
                        <use xlink:href="/assets/img/icon-sprite.svg#global.warning" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                </a>
            </span> -->
            <span class="col-auto pl-0" v-if="!checkMoisureProtection(unit)">
                            <a role="button" tabindex="0"
                               v-b-popover.hover.right="__('lang.kwl.room_overview.fl_info')">
                                <svg class="icon m-0 mb-1 text-primary">
                                    <use xlink:href="/assets/img/icon-sprite.svg#global.warning"
                                         xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                </svg>
                            </a>
                        </span>
            <hr class="w-100 my-0 mx-3"/>
            <b-collapse class="collapse w-100" :visible="index == showIndex" :id="'unit_' + index"
                        accordion="accordionUnitsDevices" @show="collapseEvent(index)">
              <div class="container-fluid"
                   v-if="checkMoisureProtection(unit) && unit.rooms.length > 0 && index == showIndex">
                <UnitCentralComponent :unitId="unit.id" :index="index" :show="showIndex == index"
                                      v-if="unit.ventilationMeasure == 3 || unit.ventilationMeasure == 4"
                                      :key="'unit_'.index"></UnitCentralComponent>
                <CombinationLtmComponent :unitId="unit.id" :index="index" :show="showIndex == index"
                                         v-else-if="unit.ventilationMeasure == 5 || unit.ventilationMeasure == 6"
                                         :key="'combination_'.index"></CombinationLtmComponent>
                <SingleRoomComponent :unitId="unit.id" :index="index" :show="showIndex == index" v-else
                                     :key="'room_'.index"></SingleRoomComponent>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Unit from "@models/building/Unit";

import pageValidation from "@services/validations/pageValidation";

import unitAirvolumes from "@services/calculations/index";

export default {
  components: {
    UnitCentralComponent: () => import("./UnitCentral/MainComponent"),
    CombinationLtmComponent: () => import("./CombinationLtm/MainComponent"),
    SingleRoomComponent: () => import("./SingleRoom/MainComponent"),
  },
  data() {

    return {
      dataLoaded: false,
      showIndex: 0,
    };
  },
  methods: {
    async nextUnit() {
      await this.$enableLoadingAnimation();
      this.$nextTick(() => {
        this.showIndex++;
      });
    },
    checkMoisureProtection(unit) {
      if (unit.ventilationMeasure != 1 || unit.ventilationMeasure != 7) return true;
      return unitAirvolumes.checkMoisureProtection(unit);
    },
    async collapseEvent(index) {
      await this.$enableLoadingAnimation();
      this.$nextTick(() => {
        if (this.showIndex == index) {
          this.$disableLoadingAnimation();
        }
        this.showIndex = index;
      });
    },
  },
  computed: {
    units() {
      return Unit.query().with("rooms").get();
    },
  },
  created() {
    this.$enableLoadingAnimation();
    pageValidation.validatePossiblePages();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>
